import { GanttAccessRightsEnum } from '@thinknet-gmbh/platform-common';

import { GanttViewsEnum } from './gantt.enums';

export const WORKING_HOURS = {
  monday: 8,
  tuesday: 8,
  wednesday: 8,
  thursday: 8,
  friday: 8,
  saturday: 6,
  sunday: 0,
};

export enum GanttColumnTypesEnum {
  WEEKEND = 'WEEKEND',
  HOLYDAY = 'HOLIDAY',
  FUTURE_DAY = 'FUTURE_DAY',
  CURRENT_DAY = 'CURRENT_DAY',
}

export const GANTT_DISABLED_DAY_COLUMN_FOR_TYPES = [
  GanttColumnTypesEnum.HOLYDAY,
  GanttColumnTypesEnum.WEEKEND,
];

export const GANTT_CONTROL_DEFAULT = {
  view: GanttViewsEnum.MONTH,
  fullScreenActive: false,
  weekendsActive: true,
  access: GanttAccessRightsEnum.VIEW,
};

export const GANTT_CALENDAR_CONTAINER_ID = 'GANTT_CALENDAR_CONTAINER_ID';
